// extracted by mini-css-extract-plugin
module.exports = {"heading":"UsersList_heading__2gPuX","deleteLink":"UsersList_deleteLink__3xt6-"};